import { render } from "./software-info.vue?vue&type=template&id=65dafb10&scoped=true&ts=true"
import script from "./software-info.vue?vue&type=script&lang=ts"
export * from "./software-info.vue?vue&type=script&lang=ts"

import "./software-info.vue?vue&type=style&index=0&id=65dafb10&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dafb10"]])

export default __exports__